export const ACTION_RESET = 'FETCH_HAPPENINGDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_HAPPENINGDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_HAPPENINGDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_HAPPENINGDATALIST_ERROR';
